import { useCallback, useState } from "react";
import { Switch } from "../../../components/inputs/Switch";
import { adminApi, extractErrorMessage } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";

export const OutOfNetworkPaRequiredToggle = ({
  payorId,
  payorName,
  requiresPaOutOfNetwork,
  cptCodeSettingId,
  cptCodeId,
  cptCode,
  onChange,
  onError,
}) => {
  const [loading, setLoading] = useState(false);
  const label = loading ? "Loading..." : requiresPaOutOfNetwork ? "Yes" : "No";

  const getUpdateMessage = useCallback(
    (requiresPaOutOfNetwork) => `Set Out of Network PA required for ${payorName} - ${cptCode} as ${requiresPaOutOfNetwork ? "Yes" : "No"}`,
    [cptCode, payorName]
  );

  const handleCreate = useCallback(async () => {
    setLoading(true);

    try {
      await adminApi.post(
        "/admin/payor_cpt_codes_settings.json",
        snakifyKeys({ payorCptCodesSetting: { requiresPaOutOfNetwork: true, payorId, cptCodeId } })
      );
      onChange(getUpdateMessage(true));
    } catch (err) {
      onError(extractErrorMessage(err));
    } finally {
      setLoading(false);
    }
  }, [cptCodeId, payorId, getUpdateMessage, setLoading, onChange, onError]);

  const handleUpdate = useCallback(
    async (e) => {
      setLoading(true);
      const requiresPaOutOfNetwork = e.target.checked;

      try {
        await adminApi.put(
          `/admin/payor_cpt_codes_settings/${cptCodeSettingId}.json`,
          snakifyKeys({ payorCptCodesSetting: { requiresPaOutOfNetwork } })
        );

        onChange(getUpdateMessage(requiresPaOutOfNetwork));
      } catch (err) {
        onError(extractErrorMessage(err));
      } finally {
        setLoading(false);
      }
    },
    [cptCodeSettingId, getUpdateMessage, setLoading, onChange, onError]
  );

  const handleChange = requiresPaOutOfNetwork === null ? handleCreate : handleUpdate;

  return (
    <Switch
      disabled={loading}
      id={`requires_pa_out_of_network_${cptCodeSettingId}`}
      checked={Boolean(requiresPaOutOfNetwork)}
      label={label}
      onChange={handleChange}
    />
  );
};
